
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[product_url]",
      function () {
        return require("private-next-pages/p/[product_url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[product_url]"])
      });
    }
  